import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from "@configs/axios";

const operations = {
  fetchTermsAndConditions: createApiService(
    (lang) => {
      return axios.get("/terms_and_conditions", {
        headers: { 'x-lang': `${lang}` }
      });
    },
    { ...API_CONFIGS.GET_OPTIONAL_DATA, context: 'User - Terms and Conditions' }
  ),

  acceptTermsAndConditions: createApiService(
    () => axios.post("/terms/accept"),
    { ...API_CONFIGS.POST_ACTION, context: 'User - Accept Terms' }
  ),

  resendActivationCode: createApiService(
    () => axios.post("/security/resendActivationCode"),
    { ...API_CONFIGS.POST_ACTION, context: 'User - Resend Activation Code' }
  ),

  fetchUserReferralsData: createApiService(
    () => axios.get("/user/referrals"),
    { ...API_CONFIGS.GET_WITH_DATA, context: 'User - Referrals Data' }
  ),
  activeTwoStepVerfication: async (data, lang) => {
    try {
      const res = await axios.post(
        "/security/setTwoFactorLogin",
        { ...data },
        {
          headers: {
            "x-lang": `${lang}`, // Replace 'your-lang-value' with the actual value you want to send
          },
        }
      );
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  deActiveTwoStepVerfication: async (lang) => {
    try {
      const res = await axios.post(
        "/security/disableTwoFactorLogin",
        { disable: true },
        {
          headers: {
            "x-lang": `${lang}`, // Replace 'your-lang-value' with the actual value you want to send
          },
        }
      );
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  createUserReferralsCode: async (percent) => {
    try {
      const res = await axios.post(`/referral/create`, { user_percent: percent }, {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchUserReferralsCodesList: async (page, query) => {
    const reqQuery = `?page=${page}&query=${query}`;
    try {
      const res = await axios.get(`/referral${reqQuery}`, {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchUserReferralIncome: async () => {
    try {
      const res = await axios.get(`/referral/info`, {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchUserReferralsInvitedUserList: async (page, query) => {
    const reqQuery = `?page=${page}&query=${query}`;
    try {
      const res = await axios.get(`/referral/invitedUsers${reqQuery}`, {});
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  activeTwoStepGoogleVerfication: async (data) => {
    try {
      const res = await axios.post("/login", { ...data });
      if (res.data) {
        return res.data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchUserTopWallets: async () => {
    try {
      const res = await axios.get("/user/profile");
      if (res.data) {
        return res.data.data.top_wallets;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
};

export default operations;
